import { useEffect, useState } from "react";

import { getColumns } from "./deco-columns";
import useAxios from "@src/utility/hooks/use-axios";
import { useParams } from "react-router-dom";

export function useHealthScore () {
    const { clientId, platformId } = useParams();
    const [data, setData] = useState({
        healthScores     : [],
        globalHealthScore: null
    });
    const columns = getColumns();

    const { axiosInstance, loading } = useAxios({ base: "panel", initialLoader: true });

    const getHealthScore = async () => {
        const { data } = await axiosInstance.get(`/health-scores/${platformId}/calculated-scores/${clientId}`);
        setData({
            healthScores     : data.individualHealthScores,
            globalHealthScore: data.globalHealthScore
        });
    };

    useEffect(() => {
        getHealthScore();
    }, []);

    return {
        loading,
        data,
        columns
    };
}